import PropTypes from 'prop-types';
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import InputController from "../../../../core/ui/components/InputController";
import AdministradorPermisos from "../../../../core/ui/components/AdministradorPermisos";

const FormPermisos = ({ modalState }) => {
    const { persona } = modalState.data;

    return (
        <Modal
            isOpen={modalState.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                {modalState.title}
            </ModalHeader>
            <ModalBody>
                <>
                    <Row>
                        <Col sm={4}>
                            <InputController
                                label="Documento"
                                name="documento"
                                value={persona.documento_persona}
                                readOnly={true}
                            />
                        </Col>
                        <Col sm={4}>
                            <InputController
                                label="Nombres"
                                name="nombres"
                                value={persona.nombre_persona}
                                readOnly={true}
                            />
                        </Col>
                        <Col sm={4}>
                            <InputController
                                label="Apellidos"
                                name="apellidos"
                                value={persona.apellido_persona}
                                readOnly={true}
                            />
                        </Col>
                    </Row>
                    <AdministradorPermisos
                        idPersona={persona.id}
                        cancelarAsignacion={() => modalState.close()}
                        asignacionCompletada={() => modalState.close()}
                    />
                </>
            </ModalBody>
        </Modal>
    );
};

FormPermisos.propTypes = {
    modalState: PropTypes.object
}

export default FormPermisos;
